{
  "name": "app",
  "version": "2.27.0",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "start:local-docker": "npm run start -- --configuration=localDocker",
    "build": "ng build",
    "build:local-docker": "npm run build -- --configuration=localDocker",
    "build:development": "npm run build -- --configuration=development",
    "build:staging": "npm run build -- --configuration=staging && npm run translate:optimize",
    "build:production": "npm run build -- --configuration=production && npm run translate:optimize",
    "lint": "ng lint",
    "translate:optimize": "transloco-optimize dist/app/assets/locales",
    "watch": "ng build --watch --configuration development",
    "test:run": "ng test --watch=false",
    "test:watch": "ng test --watch=true",
    "test:ci": "ng test --watch=false --coverage",
    "test": "npm run lint && npm run test:ci",
    "mr": "npx -y @touch4it/scripts mr"
  },
  "author": {
    "name": "Marián Vismek",
    "email": "marian.vismek@touch4it.com"
  },
  "private": true,
  "dependencies": {
    "@angular/common": "^22.2.1",
    "@angular/compiler": "^22.2.1",
    "@angular/core": "^22.2.1",
    "@angular/forms": "^22.2.1",
    "@angular/platform-browser": "^22.2.1",
    "@angular/router": "^22.2.1",
    "@jsverse/transloco-optimize": "^8.4.0",
    "@touch4it/ng-swp": "11.5.1",
    "date-fns": "^4.1.0",
    "file-saver-es": "^2.0.5",
    "generate-password-browser": "^1.1.0",
    "heic-to": "^1.5.2",
    "ng-zorro-antd": "^22.1.1",
    "ngx-mask": "^22.2.1",
    "rxjs": "~7.8.2",
    "tslib": "^2.8.1"
  },
  "devDependencies": {
    "@angular/build": "^22.2.1",
    "@angular/cli": "^22.2.1",
    "@angular/compiler-cli": "^22.2.1",
    "@jsverse/transloco": "^8.4.0",
    "@testing-library/angular": "^19.5.0",
    "@testing-library/dom": "^10.4.2",
    "@testing-library/jest-dom": "^6.9.1",
    "@touch4it/eslint-config-sandokan": "^0.25.0",
    "@types/file-saver-es": "~2.0.3",
    "@vitest/coverage-v8": "~4.1.11",
    "eslint": "^9.39.5",
    "jsdom": "^30.1.2",
    "less": "^4.2.0",
    "typescript": "~6.0.3",
    "typescript-eslint": "^8.71.0",
    "vitest": "~4.1.11"
  },
  "overrides": {
    "angular-eslint": "22.5.0"
  },
  "allowScripts": {
    "@parcel/watcher": false,
    "esbuild": false,
    "lmdb": false,
    "msgpackr-extract": false,
    "unrs-resolver": false
  }
}
